import React from "react";
import { motion } from "framer-motion";

/**
 * Section with built-in reveal animation triggered when in viewport.
 */
export function RevealSection({ children, className = "", delay = 0, y = 40 }) {
    return (
        <motion.section
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </motion.section>
    );
}

/**
 * Animated horizontal line that draws itself when scrolled into view.
 */
export function DrawnLine({ className = "" }) {
    return (
        <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, ease: [0.65, 0, 0.35, 1] }}
            style={{ transformOrigin: "left" }}
            className={`section-divider ${className}`}
        />
    );
}

/**
 * Marquee text band - infinite scroll typographic strip.
 */
export function Marquee({ children, className = "" }) {
    return (
        <div className={`overflow-hidden ${className}`}>
            <div className="flex whitespace-nowrap animate-marquee">
                {Array.from({ length: 6 }).map((_, i) => (
                    <span key={i} className="serif text-6xl md:text-8xl italic-serif text-[var(--ink-soft)] opacity-30 px-12">
                        {children}
                    </span>
                ))}
            </div>
        </div>
    );
}

/**
 * Stagger container for children reveal.
 */
export function StaggerGroup({ children, className = "", stagger = 0.08 }) {
    return (
        <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={{
                hidden: {},
                show: { transition: { staggerChildren: stagger } },
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};
